// Class: motion.easing.Linear

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing_LinearEaseNone() {return require("./../../motion/easing/LinearEaseNone");}

// Constructor

var Linear = function(){}

// Meta

Linear.__name__ = ["motion","easing","Linear"];
Linear.__isInterface__ = false;
Linear.prototype = {
	
};
Linear.prototype.__class__ = Linear.prototype.constructor = $hxClasses["motion.easing.Linear"] = Linear;

// Init

Object.defineProperties(Linear,{ "easeNone" : { get : function() {
	return Linear.get_easeNone();
}}});

// Statics

Linear.get_easeNone = function() {
	return new (motion_easing_LinearEaseNone().default)();
}


// Export

exports.default = Linear;